module.exports = __webpack_public_path__ + "img/360.a844ea66.svg";